var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home_box"},[_c('HomeHeader'),_vm._v(" "),_c('div',{staticStyle:{"height":"70px"}}),_vm._v(" "),_c('div',{staticClass:"main_body"},[_c('router-view')],1),_vm._v(" "),_c('footerInfo')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-254eeac2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/newPages/booking/home.vue
// module id = null
// module chunks = 